import React, { useEffect } from 'react';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Careers from './pages/Careers';
import Invest from './pages/Invest';
import ComingSoon from './pages/ComingSoon';
import ResearchDetail from './pages/ResearchDetail';
import NewsDetail from './pages/NewsDetail';
import JobDetail from './pages/JobDetail';
import ThankYou from './pages/ThankYou';
import './App.css';

function App() {
    useEffect(() => {
  const badge = document.getElementById("emergent-badge");
  if (badge) badge.remove();
}, []);

  return (
    <BrowserRouter>
      <div className="App">
        {/* Skip to content for accessibility */}
        <a href="#main-content" className="skip-to-content">
          Skip to content
        </a>

        <Header />
        
        <main id="main-content">
          <Routes>
            {/* Main pages */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/thank-you" element={<ThankYou />} />

            
            {/* Coming soon pages */}
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/jobs/coming-soon" element={<ComingSoon />} />
            
            {/* Research pages */}
            <Route path="/research/:project" element={<ResearchDetail />} />
            
            {/* News pages */}
            <Route path="/news/:slug" element={<NewsDetail />} />
            
            {/* Job detail pages */}
            <Route path="/jobs/:role" element={<JobDetail />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;